import { IContinuationState } from '../types/continuationScroll'

export const reducer = (
  state: IContinuationState,
  action
): IContinuationState => {
  switch (action.type) {
    case 'FETCH_ITEMS__STARTED':
      return { ...state, isLoading: true, items: action.items }
    case 'FETCH_ITEMS__SUCCESS':
      return {
        items: action.items,
        totalCount: action.totalCount,
        continuationToken: action.continuationToken,
        isLoading: false,
      }
    case 'FETCH_ITEMS__FAILURE':
      return { ...state, isLoading: false }
    default:
      return state
  }
}
